/** @jsxImportSource @emotion/react */
import { Autocomplete, Button, FormControl, FormControlLabel, FormHelperText, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { useState,useContext } from 'react';
import ElevatedGrid from '../../Components/ElevatedGrid';
import PageLayout from '../Layout/PageLayout';
import * as yup from 'yup';
import { StyledTextField } from '../../Components/CustomTextfield';
import config from '../../config';
import axios from '../../Helper/Axios/interceptor';
import { Il8nContext } from '../../Helper/i18n';
import { steps } from '../../Helper/AppStepperData';
import { useEffect } from 'react';

const IFSCFinder = (props) => {
    const {setResponseStatus, setSnackBarOpen, getOptionComponent, toggleIFSCFinder} = props
    const [IFSCCodes, setIFSCCodes] = useState([])
    const [bankNameData, setBankNameData] = useState([])
    const localeText = useContext(Il8nContext)


    const validationSchema = yup.object({        
        branchOrCity: yup
            .string('')
            .required(localeText?.bankDetailsSelection),
        bankName : yup
            .string('')
            .required(localeText?.bankDetailsSelBankName),
        branch : yup
            .string(''),
        city: yup
            .string('')
    })

    const formik = useFormik({
        initialValues: {
            branchOrCity: "branch",
            bankName: "",
            branch: "",
            city: ""
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            var dataObj = {}
            if(values.branchOrCity == "branch"){
                dataObj.bankBranch = values.branch
            }
            else{
                dataObj.cityName = values.city
            }
            dataObj.bankName = values.bankName
            axios.post(process.env.REACT_APP_API_URL + config.IFSCFinder, dataObj)
                .then(resp => {
                    if (resp.data.success) {
                        setIFSCCodes(resp.data.success)
                    }
                    else {
                        throw new Error(resp.data.error)
                    }
                }).catch((error) => {
                    setResponseStatus({ "message": error.message, "type": "error" })
                    setSnackBarOpen(true)
                })
        },
    })

    let timer;
    const handleBankSearch = (e)=>{
        if(timer){
            clearTimeout(timer)
        }
        timer = setTimeout(()=>{
            let value = e.target.value
            if(value){
                let dataObj = {}
                dataObj.key = value
                dataObj.type = "bankSearch"
                axios.post(process.env.REACT_APP_API_URL + config.search, dataObj)
                    .then(resp => {
                        if (resp.data.success) {
                            setBankNameData(resp.data.success.map(item=>item.name))
                        }
                        else {
                            throw new Error(resp.data.error)
                        }
                    }).catch((error) => {
                        setResponseStatus({ "message": error.message, "type": "error" })
                        setSnackBarOpen(true)
                    })
            }
        }, 1000)
    }

    return (
        <form autocomplete="off" onSubmit={formik.handleSubmit} css={{ width: "100%" }}>
            <PageLayout css={{ overflowY: "scroll" }} showSidebar breadcrumb={{ show: true, steps: steps[2].nestedSteps, step: 3, nestedStep: 1 }}>
                <ElevatedGrid >
                    <Grid container item alignItems={"start"} spacing={3}>
                        <Grid item xs={12}>
                            <Typography display="inline" fontSize={"24px"} fontWeight={"bold"} color="#525D72">
                                {localeText?.bankDetailsIfsc}
                            </Typography>
                            {<img src="images/icon_close_black.svg" alt="close" css={{ cursor: "pointer", float:"right" }} onClick={toggleIFSCFinder} />}
                        </Grid>
                        <Grid container item xs={12} spacing="12" >
                            <Grid item xs={12}>
                                <FormControl id="branchOrCity" name="branchOrCity" error={formik.touched.branchOrCity && Boolean(formik.errors.branchOrCity)}>
                                    <RadioGroup value={formik.values.branchOrCity} row name="row-radio-buttons-group" onChange={(e, value) => { formik.setFieldValue("branchOrCity", value) }}>
                                        <FormControlLabel value="branch" control={<Radio size='small' />} label={localeText?.bankDetailsBranch} />
                                        <FormControlLabel value="city" control={<Radio size='small' />} label={localeText?.bankDetailsCity} />
                                    </RadioGroup>
                                    <FormHelperText>{formik.touched.branchOrCity && formik.errors.branchOrCity}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <Autocomplete
                                    css={{ marginTop: "10px" }}
                                    disablePortal
                                    id="bankName" name="bankName"
                                    options={bankNameData}
                                    value={formik.values.bankName}
                                    onChange={(e)=>{
                                        formik.setFieldValue("bankName", e.target.innerText)
                                    }}
                                    renderInput={(params) => <StyledTextField {...params}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}   
                                        size="small"
                                        id="bankName" name="bankName" fullWidth variant="outlined" label={localeText?.bankDetailsBankName}
                                        onChange={handleBankSearch}
                                        error={formik.touched.bankName && Boolean(formik.errors.bankName)}
                                        helperText={formik.touched.bankName && formik.errors.bankName} 
                                    />}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                {formik.values.branchOrCity == "branch" ? 
                                    <StyledTextField id="branch" name="branch" css={{ marginTop: "10px" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={formik.values.branch}
                                        error={formik.touched.branch && Boolean(formik.errors.branch)}
                                        helperText={formik.touched.branch && formik.errors.branch} fullWidth
                                        label={localeText?.bankDetailsBranch} variant="outlined"
                                        onChange={formik.handleChange}
                                    />                                    
                                    : <StyledTextField id="city" name="city" css={{ marginTop: "10px" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={formik.values.city}
                                        error={formik.touched.city && Boolean(formik.errors.city)}
                                        helperText={formik.touched.city && formik.errors.city} fullWidth
                                        label={localeText?.bankDetailsCity} variant="outlined"
                                        onChange={formik.handleChange}
                                    />
                                }
                            </Grid>
                            <Grid item xs={12} md={3} css={{ margin: "10px 0" }}>
                                <Button type="submit" variant='contained' color="primary">
                                    {localeText?.bankDetailsSearch}
                                </Button>
                            </Grid>
                        </Grid>

                        <Grid container item xs={12}>
                            {IFSCCodes.length>0 && <Grid container item xs={12} css={{ marginTop: "5px", padding: "10px", borderRadius: "15px", border: "1px solid #0098B0", wordBreak: "break-word" }}>
                                {IFSCCodes.map((searchedItem,index) => getOptionComponent(searchedItem,index, true))}
                            </Grid>}
                        </Grid>
                    </Grid>
                </ElevatedGrid>
            </PageLayout>
        </form>
    )
}

export default IFSCFinder
